import React from "react";

const DownArrow = () => {
  return (
    <svg className="" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#8be9fd"
        d="M18.3 26.4l2-2L32 36.2l11.7-11.8 2 2L32 40.1 18.3 26.4"
      />
    </svg>
  );
};

export default DownArrow;
